import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { usePathname } from "@lib/i18n/navigation-app-router";
import {
  useUserCollectionAddress,
  useReloadUserAddresses,
  useLocalPartnerNameFor,
  useDefaultReturnHomeCarrierFor,
  useHasMultipleCollectionMethods,
} from "@hooks/use-addresses";
import carriers from "@utils/constants/carriers";
import Link from "@components/core/Link";

function ReturnModeValidation() {
  const t = useTranslations("common");

  const pathname = usePathname();

  const collectionAddress = useUserCollectionAddress();
  const reloadUserAddresses = useReloadUserAddresses();

  // a pickup address is always linked to a carrier (hence it has a carrier_name) and a home address is not (so we use the country's default return home carrier)
  const defaultReturnHomeCarrier = useDefaultReturnHomeCarrierFor(collectionAddress?.country);
  const returnCarrierName =
    collectionAddress?.delivery_mode === "pickup"
      ? collectionAddress?.carrier_name
      : carriers[defaultReturnHomeCarrier];
  const localPartnerNameForCountry = useLocalPartnerNameFor(collectionAddress?.country);
  const localPartnerName = localPartnerNameForCountry(returnCarrierName);
  const hasMultipleCollectionMethods = useHasMultipleCollectionMethods();

  useEffect(() => {
    if (!collectionAddress) reloadUserAddresses();
  }, []);

  if (!collectionAddress) {
    return null;
  }

  return (
    <div className="d-flex flex-column bg-white p-3 gap-2 rounded-sm">
      <div className="d-flex justify-content-between align-items-center">
        <p className="font-weight-bold font-size-sm text-uppercase mb-0">
          {t("drawer.modal_rtc.validate.addresses.return_mode")}
        </p>

        {hasMultipleCollectionMethods && (
          <Link
            className="link-primary no-underline"
            href={{
              pathname: "/profile/addresses/collection",
              query: {
                redirect: pathname,
                origin: "closetDrawer",
              },
            }}
          >
            {t("drawer.modal_rtc.validate.change")}
          </Link>
        )}
      </div>

      <p className="mb-0">{t(`drawer.modal_rtc.validate.addresses.carrier.${localPartnerName}`)}</p>
    </div>
  );
}

export default ReturnModeValidation;
